import { useEffect } from 'react';

import Hotjar from '../helpers/hotjar';
import { hotjarAppId, hotjarAppVersion } from '../utils/envs';
import { isInternalAccess } from '../utils/internal-access';

const useHotjar = (userData) => {
  useEffect(() => {
    const { isAdmin } = userData;

    if (isInternalAccess(isAdmin)) return;

    Hotjar.boot(hotjarAppId, hotjarAppVersion);
  }, [userData]);
};

export default useHotjar;
